import { render, staticRenderFns } from "./PreviewHelpdesk.vue?vue&type=template&id=5b6c20e3&scoped=true&"
import script from "./PreviewHelpdesk.vue?vue&type=script&lang=js&"
export * from "./PreviewHelpdesk.vue?vue&type=script&lang=js&"
import style0 from "./PreviewHelpdesk.vue?vue&type=style&index=0&id=5b6c20e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c20e3",
  null
  
)

export default component.exports